import { render, staticRenderFns } from "./Tenant.vue?vue&type=template&id=04d36b82&scoped=true"
import script from "./Tenant.vue?vue&type=script&lang=js"
export * from "./Tenant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d36b82",
  null
  
)

export default component.exports